import { AnimatePresence } from 'framer-motion';
import { useLayoutEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout.jsx';
import { ProtectedRoute } from './components/AuthContext.jsx';
import CatalogPage from './pages/CatalogPage.jsx';
import BookPage from './pages/BookPage.jsx';
import ReaderPage from './pages/ReaderPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import VerifyPage from './pages/VerifyPage.jsx';
import AdminPage from './pages/AdminPage.jsx';
import TermsPage from './pages/TermsPage.jsx';

export default function App() {
  const location = useLocation();
  useLayoutEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }, [location.pathname]);
  const reader = location.pathname.startsWith('/citeste/');
  const routes = <AnimatePresence mode="wait"><Routes location={location} key={location.pathname}>
    <Route path="/login" element={<LoginPage/>}/>
    <Route path="/verificare" element={<VerifyPage/>}/>
    <Route path="/termeni" element={<TermsPage/>}/>
    <Route path="/" element={<ProtectedRoute><CatalogPage/></ProtectedRoute>}/>
    <Route path="/carte/:id" element={<ProtectedRoute><BookPage/></ProtectedRoute>}/>
    <Route path="/citeste/:id" element={<ProtectedRoute><ReaderPage/></ProtectedRoute>}/>
    <Route path="/admin" element={<ProtectedRoute admin><AdminPage/></ProtectedRoute>}/>
    <Route path="*" element={<ProtectedRoute><CatalogPage/></ProtectedRoute>}/>
  </Routes></AnimatePresence>;
  return reader ? routes : <Layout>{routes}</Layout>;
}
